import { render, staticRenderFns } from "./mySales.vue?vue&type=template&id=3899fcf6&scoped=true&"
import script from "./mySales.vue?vue&type=script&lang=js&"
export * from "./mySales.vue?vue&type=script&lang=js&"
import style0 from "./mySales.vue?vue&type=style&index=0&id=3899fcf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899fcf6",
  null
  
)

export default component.exports